import React from 'react'

function ToolipsCustom({title,subtitle,className,classNameChild,onClick}) {
  return (
    <>

        <span 
        className={`tooltip1 tooltip-question ${className}`} 
        onClick={onClick}
        
        >
          {title}
           <span className={`tooltiptext1 ${classNameChild}`}>{subtitle}</span>
        </span>
</>
  )
}

export default ToolipsCustom
